import React from 'react';
import { formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { theme as defaultTheme } from '../../theme';
import { Step } from './components';
import { Container } from './funnel-chart.styles';
import { generateFunnel } from './utils';
export var FunnelChart = function (_a) {
    var data = _a.data, labelSelector = _a.labelSelector, _b = _a.stepLabels, stepLabels = _b === void 0 ? [] : _b, _c = _a.valueKey, valueKey = _c === void 0 ? 'value' : _c, _d = _a.layout, layout = _d === void 0 ? 'horizontal' : _d, _e = _a.theme, theme = _e === void 0 ? defaultTheme : _e, formatValues = _a.formatValues, _f = _a.margins, margins = _f === void 0 ? { top: 0, left: 0, right: 0, bottom: 0 } : _f;
    var _g = generateFunnel({
        data: data,
        key: valueKey,
        colors: theme.colors,
    }), steps = _g.steps, scale = _g.scale;
    return (React.createElement(Container, { layout: layout }, steps.map(function (_a, idx) {
        var percentageValue = _a.percentageValue, nextPercentageValue = _a.nextPercentageValue, value = _a.value, color = _a.color, index = _a.index;
        return (React.createElement(Step, { key: idx, label: stepLabels[idx] || data[index][labelSelector], theme: theme, stepsCount: steps.length, index: idx, value: valueFormatter(value, formatValues), percentageValue: percentageValue, nextPercentageValue: nextPercentageValue, color: color, scale: scale.copy(), layout: layout, margins: margins }));
    })));
};
export default FunnelChart;
